import {mapActions, mapGetters, mapMutations} from 'vuex';
import Header from '@/components/header/index.vue'
import leftBar from '@/components/left-bar/index.vue'
import Table from '@/components/table/list/index.vue'
import TableOptions from '@/components/table/options/index.vue'
import popup from "@/components/popups/templates/smsTemplates/index.vue";
import pagination from '@/components/pagination/index.vue'
import paginationMixin from '@/mixins/pagination/index.js'

export default {
    components:{
        Header,
        leftBar,
        Table,
        pagination,
        TableOptions,
        popup,
    },
    mixins: [paginationMixin],
    data(){
        return{
            // Статичні визначення полів: перекладні підписи — labelKey,
            // сам `label` обчислюється в computed fields (залежить від локалі).
            fieldDefs:[
                {
                    key: 'id',
                    label: 'ID'
                },
                {
                    key: 'sms_title',
                    labelKey: 'smsTemplates.title'
                },
                {
                    key: 'text',
                    labelKey: 'smsTemplates.text'
                },
                {
                    key: 'type',
                    labelKey: 'smsTemplates.type'
                },
            ],
            items:[],
            showWarehousePopup: false,
            selectedItem: null,
        }
    },
    computed: {
        fields() {
            return this.fieldDefs.map(field => field.labelKey
                ? { ...field, label: this.$t(field.labelKey) }
                : field);
        },
        ...mapGetters({
            menuHide:'config/menuHide',
            smsTemplates:'templates/smsTemplates',
        })
    },
    watch:{
        smsTemplates(e){
            this.items = []
            e.data.map(item=>{
                this.items.push({
                    id:item.id,
                    'sms_title': item.title,
                    'text': item.text,
                    // Значення типу обчислюємо на момент завантаження списку
                    'type': item.type ? this.$t('smsTemplates.cyrillic') : this.$t('smsTemplates.latin'),
                });
            })
            this.res = e
        },
        page(e) {
            this.getSmsTemplates({page: e, per_page: this.perPage});
        },
        perPage(e) {
            this.getSmsTemplates({page: this.page, perpage: e});
        }
    },
    created() {
        this.toggleLoadingStatus(true);
        this.getSmsTemplates({page: 1, perpage: this.perPage}).then(()=>{
            this.toggleLoadingStatus(false);
        });
    },
    methods:{
        getAllItemsInTable(){
            this.selectedItem = this.items;
            this.$refs.tableComponent.getAllItemsInTable();
        },
        changePopup(item){
            this.showSmsTemplate(item.id)
            this.showWarehousePopup = true;
        },
        editClickWarehouse(item){
            this.showWarehouse(item.id)
            this.showWarehousePopup = true;
        },
        selectItem(item){
            if(item.length){
                this.selectedItem = item;
            }else{
                this.selectedItem = null;
            }
        },
        sendWarehouse(form){
            this.addSmsTemplate(form).then(res=>{
                if(res.status){
                    this.getSmsTemplates();
                    this.$toasted.success(this.$t('toasts.template_added'),{
                        duration : 3000
                    });
                }
                this.showWarehousePopup = false;
            })
        },
        changeWarehouse(form){
            this.editSmsTemplate(form).then(res=>{
                if(res.status){
                    this.getSmsTemplates();
                    this.$toasted.success(this.$t('toasts.template_updated'),{
                        duration : 3000
                    });
                    this.showWarehousePopup = false;
                }
            })
        },
        removeItem(id){
          this.removeSmsTemplate(id).then(res=>{
              if(res.status){
                  this.getSmsTemplates();
                  this.$toasted.success(this.$t('toasts.template_deleted'),{
                      duration : 3000
                  });
                  this.showWarehousePopup = false;
              }
          })
        },
        ...mapActions({
            getSmsTemplates:'templates/getSmsTemplates',
            showSmsTemplate:'templates/showSmsTemplate',
            addSmsTemplate:'templates/addSmsTemplate',
            editSmsTemplate:'templates/editSmsTemplate',
            removeSmsTemplate:'templates/removeSmsTemplate',
        }),
        ...mapMutations({
            toggleLoadingStatus: 'config/toggleLoadingStatus',
        })
    }
}
